import {atom} from "recoil";


const activateFilter = atom({
  key: 'activateFilter',
  default: "",
 });


 export default activateFilter;
